const fetchImage = url => new Promise((resolve, reject) => {
    const im = new Image();
    im.crossOrigin = 'Anonymous';
    im.onload = () => {
        resolve(im);
    };
    im.onerror = () => {
        reject();
    };
    im.src = url;
});
const toObjectUrl = canvas => {
    const promise = new Promise((resolve, reject) => {
        if (!canvas) {
            reject();
        }
        else {
            if (canvas.toBlob) {
                canvas.toBlob(blob => {
                    resolve(URL.createObjectURL(blob));
                }, 'image/png', 1);
            }
            else if (canvas.msToBlob) {
                const blob = canvas.msToBlob();
                resolve(URL.createObjectURL(blob));
            }
            else {
                const data = canvas.toDataURL('image/png', 1);
                resolve(data);
            }
        }
    });
    return promise;
};
export const convertRotateImg = (url, orientation) => new Promise((resolve, reject) => {
    fetchImage(url).then((img) => {
        const { naturalHeight: height, naturalWidth: width } = img;
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const direction = ((orientation + 360) % 360) / 90;
        switch (direction) {
            case 1: {
                canvas.width = height;
                canvas.height = width;
                ctx.rotate((90 * Math.PI) / 180);
                ctx.drawImage(img, 0, -height);
                break;
            }
            case 2: {
                canvas.width = width;
                canvas.height = height;
                ctx.rotate((180 * Math.PI) / 180);
                ctx.drawImage(img, -width, -height);
                break;
            }
            case 3: {
                canvas.width = height;
                canvas.height = width;
                ctx.rotate((270 * Math.PI) / 180);
                ctx.drawImage(img, -width, 0);
                break;
            }
            case 0:
            case 4:
            default: {
                canvas.width = width;
                canvas.height = height;
                ctx.rotate(0);
                ctx.drawImage(img, 0, 0);
                break;
            }
        }
        toObjectUrl(canvas).then(resolve, reject);
    });
});
